import React from 'react';
// styles
import Color from 'color';
import styles from './DayNames.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const DayNames = ({ color }) => {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  return (
    <div
      className={cx('wrapper')}
      style={{ backgroundColor: Color(color).fade(0.2) }}
    >
      {days.map((day, index) => (
        <span key={index} className={cx('day')}>
          {day}
        </span>
      ))}
    </div>
  );
};

export default DayNames;



// WEBPACK FOOTER //
// ./src/components/Calendar/components/DayNames.jsx